<template>
  <div class="container">
    <!--添加工作室成员概况模块-->
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">工作室概况</div>
        <div class="title-desc">工作室整体每日的收益及互动数据</div>
      </div>
      <div class="content-inner-wrap">
        <div class="data-filter">
          <span class="mgr25">数据维度 </span>
          <span class="btnGroup">
            <van-button
              @click="changeOverviewType(1)"
              :class="{ active: overviewType == 1 }"
              size="medium"
              >收益</van-button
            >
            <van-button
              @click="changeOverviewType(2)"
              :class="{ active: overviewType == 2 }"
              size="medium"
              >互动</van-button
            >
          </span>
        </div>
        <div class="data-filter">
          <date-selector
            v-model="studioDate"
            @change="studioDateChange"
            :queryBtnClick="handleSDateBtnClicked"
          ></date-selector>
        </div>
        <div
          class="data-table"
          v-if="studioData.length || studioViewData.length"
        >
          <!--收益数据-->
          <my-table
            :tableData="studioData"
            :tableField="studioDataField"
            v-if="overviewType == 1"
          >
          </my-table>
          <!--互动数据-->
          <my-table
            :tableData="studioViewData"
            :tableField="studioViewDataField"
            v-else
          >
          </my-table>
          <van-loading
            class="img-loading"
            type="spinner"
            color="#fd9b21"
            size="24px"
            v-show="studioDataLoading"
          />
        </div>
        <NoData v-else></NoData>
        <div class="data-filter-page" v-if="overviewType == 1">
          <Pagination
            :tableInfo="studioPagination"
            @changCurrentPage="sDPaginationChange"
          ></Pagination>
        </div>
        <div class="data-filter-page" v-else>
          <Pagination
            :tableInfo="studioViewPagination"
            @changCurrentPage="oDPaginationChange"
          ></Pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getStudioOverview, getStudioDayIncomeData } from '@/api/studio';
import DateSelector from '../../../../components/DateSelector.vue';
import MyTable from '../../../../components/MyTable.vue';
import NoData from '@/components/NoData.vue';
import Pagination from '../../../income/components/pagination.vue';
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 24 * 60 * 60 * 1000;
export default {
  components: {
    DateSelector,
    MyTable,
    Pagination,
    NoData
  },
  data() {
    return {
      studioDataLoading: false,
      studioPagination: {
        page_size: 5,
        page: 1,
        total: 0,
      },
      studioViewPagination: {
        page_size: 5,
        page: 1,
        total: 0,
      },
      studioDate: '',
      overviewType: '1',
      lastStudioDate: [],
      studioData: [],
      studioViewData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      studioDataField: [
        { label: '日期', prop: 'date' },
        { prop: '', label: '' },
        { label: '广告播放次数', prop: 'ad_count' },
        { label: '广告收益', prop: 'ad_income' },
        { label: '迷你点数量', prop: 'minipoint' },
        { label: '贡献点数量', prop: 'contribution' },
        { label: '迷你豆', prop: 'minibean' },
      ],
      studioViewDataField: [
        { prop: 'date', label: '日期' },
        { prop: '', label: '' },
        { prop: 'new_map_count', label: '新增地图数' },
        { prop: 'download', label: '地图总下载次数' },
        { prop: 'play_count', label: '游玩次数' },
        { prop: 'play_time', label: '游玩时长（分）' },
        { prop: 'comment', label: '评论' },
        { prop: 'collect', label: '收藏' },
      ],
    };
  },
  created() {
    //const currTime = Date.now().
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.studioDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
  },
  mounted() {
    //概况-互动数据
    this.getOverviewData();
    //概况-收益
    this.getStudioDayIncome();
  },
  filters: {
    MemberTypeFilter(type) {
      return type ? '签约成员' : '普通成员';
    },
  },
  methods: {
    //概况表点击搜索
    handleSDateBtnClicked() {
      if (this.overviewType == 1) {
        // if (this.lastStudioDate[0] === this.studioDate[0] && this.lastStudioDate[1] === this.studioDate[1]) return
        this.getStudioDayIncome();
      } else {
        //  if (this.lastStudioDate[0] === this.studioDate[0] && this.lastStudioDate[1] === this.studioDate[1]) return
        this.getOverviewData();
      }
    },
    changeOverviewType(num) {
      this.overviewType = num;
    },
    studioDateChange() {
      console.log('studioDateChange', this.studioDate);
    },
    //概况-互动表分页
    oDPaginationChange(currPage) {
      this.studioViewPagination.page = currPage;
      this.getOverviewData();
    },
    //收益表分页
    sDPaginationChange(currPage) {
      this.studioPagination.page = currPage;
      this.getStudioDayIncome();
    },
    //工作室概况表-收益
    async getStudioDayIncome() {
      this.studioDataLoading = true;
      this.lastStudioDate = this.studioDate;
      const res = await getStudioDayIncomeData(
        Object.assign(
          {
            page: this.studioPagination.page,
            page_size: this.studioPagination.page_size,
          },
          {
            start_time: parseInt(this.studioDate[0] / 1000, 10),
            end_time: parseInt((this.studioDate[1] + ONE_DAY_TIME) / 1000, 10),
          },
        ),
      );
      this.studioDataLoading = false;
      if (res.data) {
        const list = res.data.list;
        if (list && list.length) {
          this.studioData = list.map(item => {
            item.ad_income = Number(item.ad_income).toFixed(2);
            item.contribution = Number(item.contribution).toFixed(3);
            return item;
          });
        }
        this.studioPagination.total = parseInt(res.data.total_count, 10);
      }
    },
    //工作室概况表获取互动数据
    async getOverviewData() {
      this.studioDataLoading = true;
      this.lastStudioDate = JSON.parse(JSON.stringify(this.studioDate));
      const res = await getStudioOverview(
        Object.assign(
          {
            page: this.studioViewPagination.page,
            page_size: this.studioViewPagination.page_size,
          },
          {
            start_time: parseInt(this.studioDate[0] / 1000, 10),
            end_time: parseInt((this.studioDate[1] + ONE_DAY_TIME) / 1000, 10),
            json: 1,
          },
        ),
      );

      this.studioDataLoading = false;
      if (res.data) {
        const list = res.data.list;
        if (list && list.length) {
          this.studioViewData = list.map(item => {
            item.play_time = Number(item.play_time).toFixed(2);
            return item;
          });
        }
        this.studioViewPagination.total = parseInt(res.data.total_count, 10);
      }
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.less"
  lang="less"
  scoped
></style>
<style lang="less" scoped>
.container {
  .container {
    .data-table {
      margin-top: 28px;
      // border: 1px solid #d9d9d9;
      overflow: hidden;
      border-radius: 3px;
      /deep/ .table-content .table {
        margin: 0;
      }
    }
    .search_btn {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: 0;
      color: #595959;
    }
  }
}
</style>
